<!--
 * @Author: your name
 * @Date: 2021-08-26 09:49:59
 * @LastEditTime: 2021-11-08 09:40:10
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/components/login/close.vue
-->
<template>
  <div class="close" @click="returnHistory">
    <img src="../../assets/img/registrationLogin/close.png" alt />
  </div>
</template>

<script>
import { whatEev,GetQueryValue } from '@/utils/tools';
import { HOST } from '@/utils/common'
import wx from 'weixin-js-sdk';

export default {
  props: ['fromPath'],
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    returnHistory() {
      // 对于来自b站订单发货的，直接返回上一级
      console.log('判断',this.fromPath === '/' || this.fromPath === '' || window.history.length < 3);
      console.log('this.fromPath',this.fromPath, window.history.length);
      if(this.$root.miniprogram){
        wx.miniProgram.navigateBack();
      }
      if (this.fromPath === '/bilibili-shipments/1') {
        this.$router.back();
      } else if (this.fromPath === '/' || this.fromPath === '' || window.history.length < 3 || this.$route?.query?.redirect?.indexOf('question') > -1) {
        const questionSourceType = GetQueryValue('questionSourceType');
        if (Number(questionSourceType) === 1) {
          const routeUrl = this.$router.resolve({
            path: this.$route.query.redirect,
            query: JSON.parse(this.urlParams),
          });
          console.log('linkUrl', `${HOST}${routeUrl.resolved.fullPath}`);
          window.location.href = `${HOST}${routeUrl.resolved.fullPath}`;
          return;
        }
        if (whatEev() === 'wechatBrowser') {
          // 微信浏览器
          this.$router.back();
        } else {
          this.$router.replace('/home');
        }
      } else {
        this.$router.back();
      }
      this.$store.dispatch('saveUserPhone', '');
      window.localStorage.removeItem('pagesQuery');
      window.localStorage.removeItem('pagesParams');
      // window.localStorage.removeItem('fromPath');
    },
  },
  created() {
    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');
  },
};
</script>
<style lang="scss" scoped>
.close {
  padding: 0.22rem 0 0 0.65rem;
}

img {
  width: 43px;
  height: 43px;
}
</style>
